<template>
    <div class="row">

        <div class="col-md-12">
            <table class="table striped">
                <thead>
                    <tr>
                        <td :colspan="users.length + 1">
                            <search-input
                                :url="usersSearchEndpoint"
                                :searchParams="searchParams"
                                v-on:search-complete="onSearchResults"
                                v-on:search-button-pressed="onSearchRequested"
                            ></search-input>
                        </td>
                    </tr>
                    <tr>
                        <th style="width: 10%" class="is-bold">Inventory</th>
                        <th class="is-bold" v-for="user in users">{{ user.full_name}}</th>
                    </tr>
                </thead>
                <tbody :class="{ 'loading': isLoading}">
                    <tr v-for="(inventory, bookingId) in inventories">
                        <td class="is-bold">{{ inventory.name }}</td>
                        <td v-for="user in users">
                            <toggle-switch
                                :value="doesUserHaveAccessToBooking(user, bookingId)"
                                :name="inventory.name + '-' + user.id"
                                :id="inventory.id + '-' + user.id"
                                @input="toggleAccess(user, bookingId, $event)"
                            ></toggle-switch>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td :colspan="users.length + 1">
                            <simple-pagination
                                v-model="paginatedResponse"
                                v-on:page-change-requested="changePageData"
                            ></simple-pagination>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>



    </div>
</template>

<script>

import Users from '../Services/Users'
import Companies from '../Services/Companies'
import Access from '../Services/Access'
import Endpoints from '../Config/Endpoints'
import API from '../Services/API'

export default {
        name: "CompanyManageAccessComponent",

        props: {
            companyId: Number,
            centreId: Number,
        },

        data: function () {
          return {
              inventories: [],
              users: [],
              paginatedResponse: {},
              usersSearchEndpoint: '',
              isLoading: true,
              searchParams: {
                  company_id: this.companyId
              }
          }
        },

        methods: {

            getInventories: function () {
                let self = this;

                Companies.getInventoriesForActiveBookings(self.centreId, self.companyId).then(response => {
                    self.inventories = response;
                });
            },

            getUsers: function() {
                let self = this;
                self.isLoading = true;

                Users.getCompanyUsers(self.companyId).then(response => {
                    self.changePageData(response.data);
                    self.paginatedResponse = response;
                    self.isLoading = false;
                });
            },


            doesUserHaveAccessToBooking: function (user, bookingId) {

                if(!user.access_groups_for) {
                    return false;
                }

                var findings = user.access_groups_for.findIndex((accessGroup) => {

                    if (!accessGroup.booking_id) {
                        return false;
                    }


                    return parseInt(accessGroup.booking_id) === parseInt(bookingId);
                });

                return findings > -1;
            },

            toggleAccess: function (user, bookingId) {

                let enableOrDisable  = !this.doesUserHaveAccessToBooking(user, bookingId);

                Access.toggleForBooking(bookingId, user.id, enableOrDisable).then(response => {
                    this.refreshUser(user);
                });
            },

            onSearchResults: function (response) {

                this.isLoading = false;

                if (response.query === '') {
                    this.getUsers();
                    return;
                }

                this.paginatedResponse = {};
                this.changePageData(response.response.data.users);
            },

            onSearchRequested: function () {
                this.isLoading = true;
            },

            changePageData: function (data) {
                this.users = [];

                this.$nextTick().then(() => {
                    this.users = data;
                });
            },

            refreshUser: function (user) {

                Users.getCompanyUserById(this.companyId, user.id).then((response) => {
                    let ind = this.users.findIndex((userToProcess) => {
                        return userToProcess.id === response.id;
                    });
                    this.$set(this.users, ind, response);
                });
            }

        },

        computed: {

        },

        mounted() {
            this.getInventories();
            this.getUsers();

            this.usersSearchEndpoint = API.url(Endpoints.Users.SearchByNameAndCompanyId);
        },
    }
</script>

<style scoped>
    .loading {
        opacity: .4;
    }

    .is-bold {
        font-weight: bold;
    }
</style>
